import { IconPaths, ModalSize } from '../../../../../../../_metronic/helpers'
import { useT } from '_metronic/i18n/Metronici18n'
import { Button, useModal } from '../../../../../../components'
import { ClientesModal } from '../modal/ClientesModal'

export const ClientesListToolbar = () => {
  const { showModal } = useModal()
  const { t } = useT()

  const openAddCliente = () =>
    showModal({
      title: t('entidade.label'),
      content: <ClientesModal />,
      size: ModalSize.ExtraLarge,
    })

  return (
    <Button onClick={openAddCliente} icon={IconPaths.Add} className='btn-primary'>
      {t('common.add')}
    </Button>
  )
}
